import { LabworkListFilterInput } from 'gql/types';
import { TFunction } from 'i18next';
import { FiltersConfig } from 'modules/common/components/FilterChips/types';
import { formatEnum } from 'modules/common/utils/formatEnum';

export const createGeneralLabworkChipsConfig = (
  t: TFunction
): FiltersConfig<LabworkListFilterInput> => ({
  statuses: {
    label: t('status'),
    renderValue: formatEnum,
  },
  locationName: {
    label: t('location'),
  },
});

export const excludedFilterFields: (keyof LabworkListFilterInput)[] = [
  'searchingQuery',
  'donorId',
];
